import { useState } from 'react';
import { faqs } from '@/mocks/faqs';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full mb-4 font-label">
            常见问题
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            你有疑问，我有答案
          </h2>
          <p className="text-foreground-600 text-sm">
            关于蜜桃臀训练最常见的问题，专业教练为你一一解答
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/60 rounded-lg overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-foreground-900 font-medium text-sm pr-2">
                  {faq.question}
                </span>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-foreground-400">
                  <i
                    className={`ri-${
                      openIndex === index ? 'subtract' : 'add'
                    }-line text-lg transition-transform duration-200`}
                  ></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <div className="pt-2 border-t border-background-200/60">
                    <p className="text-foreground-600 text-sm leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}